import { React, useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import { getClass } from "../services/APIClient";
import AssignAssessmentOverview from "../components/AssignAssessmentOverview";
import OrientationPrompt from "../components/OrientationPrompt";

function AssignAssessment(props) {
  const location = useLocation();
  let name = location.state.name.name;
  let gradeLevel = location.state.gradeLevel.gradeLevel;
  let schoolid = location.state.schoolid.schoolid;
  let countryId = location.state.countryId.countryId;
  let students = location.state?.students?.students;
  let classid = location.state.classDetails.classDetails.id;
  let teacherid = location.state.classDetails.classDetails.teacherId;
  let isJIOnlyTrial = location.state?.isJIOnlyTrial ?? false;
  let isPilot = location.state?.isPilot ?? false;
  let latestPurchase = location.state?.latestPurchase ?? null;
  let purchaseAccessError = location.state?.purchaseAccessError ?? false;

  const [group, setGroup] = useState("");
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    getClass(classid).then((response) => {
      setGroup(response);
    });
  }, [classid]);

  let sharedWith = group.sharedWith;

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        isLoggedIn={true}
        cloud={true}
        name={name}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          <AssignAssessmentOverview
            classDetails={location.state.classDetails}
            teachers={location.state.teachers}
            sharedWith={sharedWith}
            name={name}
            gradeLevel={gradeLevel}
            students={students}
            teacherid={teacherid}
            schoolid={schoolid}
            countryId={countryId}
            isJIOnlyTrial={isJIOnlyTrial}
            isPilot={isPilot}
            latestPurchase={latestPurchase}
            purchaseAccessError={purchaseAccessError}
          />
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default AssignAssessment;
